import { put, call } from 'redux-saga/effects';

import { Types } from './actions';
import UploadValidationDataRepository from '@/data/repositories/UploadValidationDataRepository';

export default function* execute(action: any): any {
  try {
    const { imgBase64 } = action;
    yield put({ type: Types.UPLOAD_VALIDATION_REQUEST });
    const uploadValidationRepository: UploadValidationDataRepository =
      new UploadValidationDataRepository();
    const uploadValidationResponse = yield call(
      uploadValidationRepository.uploadValidation,
      imgBase64
    );
    yield put({
      type: Types.UPLOAD_VALIDATION_SUCCESS,
      data: uploadValidationResponse
    });
  } catch (error) {
    yield put({
      type: Types.UPLOAD_VALIDATION_FAILURE,
      error: 'Ocurrió un error al momento de subir la imagen.'
    });
  }
}
